/** Created by azhou on 2019/3/18.*/
<template>
    <div>
      <public-title>账号设置</public-title>
      <div class="load-area">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="item.name" :name="item.val" :key="item.name" v-for="item in isGroup?enterpriseTabArr:tabArr"/>
        </el-tabs>
        <account class="w-75 m-auto pt-4" v-show="activeName === 'account'" />
        <pwd-set class="w-75 m-auto pt-4" v-show="activeName === 'password'" />
        <phone-set class="w-75 m-auto pt-4" v-show="activeName === 'phone'"/>
        <wechat-set class="w-75 m-auto pt-4" v-if="activeName === 'wechat'"/>
        <email-set class="w-75 m-auto pt-4" v-show="activeName === 'email'"/>
        <!-- 身份认证 -->
        <identity-certification v-show="activeName === 'identity'"/>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Account from './Components/Account'
  import PwdSet from './Components/PwdSet'
  import PhoneSet from './Components/PhoneSet'
  import WechatSet from './Components/WechatSet'
  import EmailSet from './Components/EmailSet'
  import IdentityCertification from './Components/IdentityCertification'
  export default {
    name: 'AccountSet',
    components:{ Account, PwdSet,PhoneSet,WechatSet,EmailSet,IdentityCertification },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      activeType() { return this.$route.query.type }
    },
    data() {  
      return {
        tabArr:[
          {name:'密码修改',val:'password'},
          {name:'手机绑定',val:'phone'},
          {name:'微信绑定',val:'wechat'},
          {name:'身份认证',val:'identity'},
          // {name:'邮箱绑定',val:'email'},
        ],
        enterpriseTabArr:[
          {name:'账号修改',val:'account'},
          {name:'密码修改',val:'password'},
        ],
        activeName:'password'
      }
    },
    created() {
      if (this.isGroup) {
        this.activeName = 'account'
      };
      if (this.activeType) this.activeName = this.activeType;
    },
    watch:{
      activeType(newVal) { this.activeName = newVal; },
      activeName(newVal) { this.$router.push({name:this.$route.name,query:{type:newVal}}, ()=>{}, ()=>{}) }
    }
  }
</script>
<style lang="scss" scoped>
    .load-area{
        min-width: 1200px;
        border-radius: 6px;
    }
</style>
